__turbopack_context__.v({
  "buySectionContainer": "diesel-ring-client-module__DpD7vq__buySectionContainer",
});
